export const evalISOProgress = (data: any): number => {
    if (!data && !Array.isArray(data)) return 0;
    return data.length > 0? 100: 0;
}